export const navLinks = [
  { key: "comments", label: "神回复" },
  { key: "jokes", label: "沙雕段子" },
  { key: "memes", label: "梗图表情包" },
  { key: "rank", label: "热评榜" },
  { key: "about", label: "关于我们" },
];

export const hotWords = [
  "还差一丢丢",
  "你不对劲",
  "但凡有粒花生米",
  "这就很离谱",
  "尊嘟假嘟",
  "优雅永不过时",
  "我直接好家伙",
  "有被冒犯到",
];

export const feedTabs = [
  { key: "all", label: "全部" },
  { key: "reply", label: "神回复" },
  { key: "gossip", label: "网友热评" },
  { key: "meme", label: "表情包" },
];

export type FeedItem = {
  id: number;
  type: string;
  tag: string;
  topic: string;
  content: string;
  author: string;
  avatar: string;
  like: number;
  comment: number;
  tagColor: string;
};

export const feedItems: FeedItem[] = [
  {
    id: 1,
    type: "reply",
    tag: "神回复",
    topic: "#为什么周五的下午总是格外快乐#",
    content:
      "因为那四个小时里，你既不属于今天，也不属于明天，属于一个叫\u201c自由\u201d的瞬间。老板的灵魂还没追上你。",
    author: "摸鱼界天花板",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20cute%20cat%20wearing%20headphones%20working%20at%20desk%20meme%20style%20flat%20illustration%20playful&width=96&height=96&seq=av1&orientation=squarish",
    like: 12876,
    comment: 532,
    tagColor: "accent",
  },
  {
    id: 2,
    type: "joke",
    tag: "段子",
    topic: "#当代年轻人现状#",
    content:
      "白天：我是社恐，不想说话。晚上：网络一线牵，珍惜这段缘。凌晨三点：在陌生群里指点江山，句句都是人生导师。",
    author: "熬夜冠军选手",
    avatar: "https://readdy.ai/api/search-image?query=cute%20cartoon%20owl%20with%20mug%20of%20coffee%20at%20night%20flat%20illustration%20funny&width=96&height=96&seq=av2&orientation=squarish",
    like: 9763,
    comment: 421,
    tagColor: "primary",
  },
  {
    id: 3,
    type: "gossip",
    tag: "热评",
    topic: "#减肥flag已经立了第108次#",
    content:
      "减肥是我和肉之间的事，和我的嘴无关。毕竟，是肉先动手缠上我的。",
    author: "干饭王本王",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20happy%20panda%20eating%20bowl%20of%20rice%20flat%20illustration%20cute&width=96&height=96&seq=av3&orientation=squarish",
    like: 8451,
    comment: 301,
    tagColor: "secondary",
  },
  {
    id: 4,
    type: "reply",
    tag: "神回复",
    topic: "#上班和上学哪个更累#",
    content:
      "上学是白天上课晚上写作业，上班是白天上班晚上还想白天的事。这么一算，上班连\u201c放学\u201d这个概念都失去了。",
    author: "打工人实录",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20tired%20office%20worker%20suit%20tying%20tie%20flat%20illustration%20funny%20meme&width=96&height=96&seq=av4&orientation=squarish",
    like: 15230,
    comment: 688,
    tagColor: "accent",
  },
  {
    id: 5,
    type: "meme",
    tag: "表情包",
    topic: "#万能回复表情包#",
    content:
      "当对方发来\u201c在吗\u201d，又没说下文，你就知道那张脸此刻的表情有多精彩。存图可救急，回复需谨慎。",
    author: "表情包仓库",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20meme%20face%20yellow%20emoji%20style%20laughing%20flat%20illustration%20playful&width=96&height=96&seq=av5&orientation=squarish",
    like: 11402,
    comment: 467,
    tagColor: "primary",
  },
  {
    id: 6,
    type: "joke",
    tag: "段子",
    topic: "#今日份沙雕新闻#",
    content:
      "一男子报警称自己的车被偷，民警半小时后在原地找到车，原来是男子忘了自己把车停在这，去别处找了一圈。当事人：我这是严谨。",
    author: "每日一瓜",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20duck%20with%20magnifying%20glass%20searching%20flat%20illustration%20funny%20meme&width=96&height=96&seq=av6&orientation=squarish",
    like: 6934,
    comment: 277,
    tagColor: "secondary",
  },
  {
    id: 7,
    type: "gossip",
    tag: "热评",
    topic: "#秋天第一杯奶茶卷土重来#",
    content:
      "奶茶本无错，是社交赋予了它灵魂。今天不想喝奶茶，但想被惦记，所以我干了这杯秋天的仪式感。",
    author: "微糖去冰",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20cute%20bubble%20tea%20cup%20happy%20face%20flat%20illustration%20colorful&width=96&height=96&seq=av7&orientation=squarish",
    like: 5810,
    comment: 214,
    tagColor: "accent",
  },
  {
    id: 8,
    type: "reply",
    tag: "神回复",
    topic: "#相亲到底要不要 AA#",
    content:
      "能问到这一步，说明这顿已经吃完了。问题从来不是 AA 不 AA，而是你俩还有没有第二顿。",
    author: "人间清醒bot",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20fox%20with%20glasses%20thinking%20smart%20flat%20illustration%20funny%20meme&width=96&height=96&seq=av8&orientation=squarish",
    like: 13277,
    comment: 590,
    tagColor: "primary",
  },
];

export type MemeItem = {
  id: number;
  title: string;
  subtitle: string;
  image: string;
  like: number;
};

export const memeItems: MemeItem[] = [
  {
    id: 1,
    title: "优雅永不过时",
    subtitle: "吃瓜群众优雅开场",
    image: "https://readdy.ai/api/search-image?query=cartoon%20funny%20meme%20cat%20with%20sunglasses%20sipping%20watermelon%20juice%20flat%20illustration%20bright%20colorful%20playful%20internet%20meme%20style&width=600&height=520&seq=meme1&orientation=squarish",
    like: 3210,
  },
  {
    id: 2,
    title: "我直接好家伙",
    subtitle: "看到神操作的你",
    image: "https://readdy.ai/api/search-image?query=cartoon%20dog%20amazed%20open%20mouth%20shocked%20expression%20flat%20illustration%20bright%20colorful%20funny%20meme%20internet%20style&width=600&height=520&seq=meme2&orientation=squarish",
    like: 2840,
  },
  {
    id: 3,
    title: "有被冒犯到",
    subtitle: "扎心但是真实",
    image: "https://readdy.ai/api/search-image?query=cartoon%20sad%20but%20funny%20sloth%20facepalm%20expression%20flat%20illustration%20bright%20colorful%20playful%20internet%20meme&width=600&height=520&seq=meme3&orientation=squarish",
    like: 2655,
  },
  {
    id: 4,
    title: "你再这样我要报警了",
    subtitle: "无奈又拿你没办法",
    image: "https://readdy.ai/api/search-image?query=cartoon%20annoyed%20but%20loving%20bear%20holding%20phone%20exasperated%20expression%20flat%20illustration%20bright%20funny%20meme%20style&width=600&height=520&seq=meme4&orientation=squarish",
    like: 2319,
  },
  {
    id: 5,
    title: "就很离谱",
    subtitle: "离谱他妈给离谱开门",
    image: "https://readdy.ai/api/search-image?query=cartoon%20surprised%20raccoon%20wide%20eyes%20incredible%20expression%20flat%20illustration%20bright%20colorful%20funny%20internet%20meme&width=600&height=520&seq=meme5&orientation=squarish",
    like: 2107,
  },
  {
    id: 6,
    title: "吃瓜吃到自己家",
    subtitle: "围观翻车的经典现场",
    image: "https://readdy.ai/api/search-image?query=cartoon%20cat%20holding%20popcorn%20watching%20drama%20shocked%20flat%20illustration%20bright%20colorful%20playful%20meme%20internet%20style&width=600&height=520&seq=meme6&orientation=squarish",
    like: 1984,
  },
];

export type RankItem = {
  rank: number;
  text: string;
  heat: number;
  trend: "up" | "down" | "flat";
};

export const rankItems: RankItem[] = [
  { rank: 1, text: "年轻人为什么开始反向消费", heat: 98600, trend: "up" },
  { rank: 2, text: "上班族的终极自救：周五下午", heat: 82100, trend: "up" },
  { rank: 3, text: "秋天的第一杯奶茶塌房了", heat: 75300, trend: "down" },
  { rank: 4, text: "人类幼崽迷惑行为大赏", heat: 69700, trend: "up" },
  { rank: 5, text: "万能回复\u201c在吗\u201d表情包", heat: 62100, trend: "flat" },
  { rank: 6, text: "减肥 flag 的正确打开方式", heat: 55800, trend: "down" },
  { rank: 7, text: "相亲 AA 引发的世纪辩论", heat: 49300, trend: "up" },
  { rank: 8, text: "人均社牛的深夜群聊", heat: 43700, trend: "up" },
  { rank: 9, text: "离谱新闻：我把车停哪了", heat: 38200, trend: "flat" },
  { rank: 10, text: "内耗自救指南全网刷屏", heat: 33600, trend: "down" },
];

export type MarqueeItem = {
  id: number;
  text: string;
  color: string;
};

export const marqueeItems: MarqueeItem[] = [
  { id: 1, text: "你不对劲，再说一遍？", color: "primary" },
  { id: 2, text: "但凡有粒花生米也不至于", color: "accent" },
  { id: 3, text: "尊嘟假嘟，我真的会谢", color: "secondary" },
  { id: 4, text: "我已经在网线这头笑疯了", color: "primary" },
  { id: 5, text: "这就是传说中的网络喷子？不，是网络喷瓜", color: "accent" },
  { id: 6, text: "今日份快乐是评论区给的", color: "secondary" },
  { id: 7, text: "屏幕前的你别憋着，笑出来吧", color: "primary" },
  { id: 8, text: "这届网友真是梗王本王", color: "accent" },
];

export type Testimonial = {
  id: number;
  name: string;
  role: string;
  avatar: string;
  text: string;
};

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "柠檬不酸",
    role: "上班摸鱼重度用户",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20friendly%20girl%20avatar%20smiling%20flat%20illustration%20bright%20colorful%20portrait&width=96&height=96&seq=t1&orientation=squarish",
    text: "每天午休的快乐源泉，神回复比正片精彩一百倍，看完只想说一句：在座各位都是人才。",
  },
  {
    id: 2,
    name: "锅包肉不加糖",
    role: "表情包收藏家",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20boy%20avatar%20laughing%20flat%20illustration%20bright%20colorful%20portrait&width=96&height=96&seq=t2&orientation=squarish",
    text: "这里的梗图质量是真的高，跟朋友斗图再也不愁没弹药了，收藏夹已经存了三百张。",
  },
  {
    id: 3,
    name: "今晚月色真美",
    role: "深夜潜水党",
    avatar: "https://readdy.ai/api/search-image?query=cartoon%20girl%20avatar%20with%20headphones%20flat%20illustration%20bright%20colorful%20portrait&width=96&height=96&seq=t3&orientation=squarish",
    text: "看热闹我是专业的，评论区永远有惊喜。好多次笑着笑着就被一条神评戳中，又哭又笑的。",
  },
];

export type Faq = {
  q: string;
  a: string;
};

export const faqItems: Faq[] = [
  {
    q: "吃瓜快手是什么平台？",
    a: "吃瓜快手是一个专注聚合网友热评、神回复、沙雕段子、梗图和表情包的娱乐内容社区。我们每天从全网海量讨论中，把最有才、最好笑的评论挑选出来，让你用最少的时间刷到最足的快乐。",
  },
  {
    q: "内容从哪里来？",
    a: "内容主要来自各社交平台的公开讨论、网友投稿和我们的编辑精选。我们会优先标注来源话题，尽量还原原汁原味的评论语境，并在需要时与投稿人取得联系确认授权。",
  },
  {
    q: "如何投稿我看到的段子或神回复？",
    a: "你可以在任意内容页底部点击\u201c我来投稿\u201d按钮，或通过站内投稿入口填写文字内容、原话题链接。审核通过后我们会署名推荐并送出站内勋章，欢迎把压箱底的梗都砸过来。",
  },
  {
    q: "可以下载和转发这里的表情包吗？",
    a: "可以。站内标注为\u201c可下载\u201d的表情包和梗图支持免费下载与个人转发，但请勿用于商业用途或去除水印后二次传播。涉及他人肖像的内容我们会做脱敏处理。",
  },
  {
    q: "每天内容多久更新一次？",
    a: "核心热评与热搜榜实时滚动更新，神回复、段子等栏目每天分早中晚三档刷新。订阅我们的每日推送，第一时间接收当天最好笑的三条，绝不让你错过任何一个梗。",
  },
  {
    q: "遇到不适内容如何反馈？",
    a: "每条内容下方都设有\u201c举报\u201d入口。我们会对涉及侵权、低俗、引战或虚假信息的内容在 24 小时内复核处理，并定期公开清理结果，努力守护一个轻松友善的吃瓜氛围。",
  },
];